import React, { Component } from 'react';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import { isEmpty, not } from 'ramda';
import { regExForEmail } from 'constants/Regularexpression'; // regular expressions to validate user input
import FullScreenLoader from 'components/FullScreenLoader';// to show loder on screen whenever there is a api call or operations in component

import TextField from 'components/TextField';
import Password from 'components/Password';
import Category from 'components/SignupCategory';


import CustomButton from '../CustomButton';


export class Signup extends Component {


  static propTypes = {
    error: PropTypes.shape(),
    registerUser: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    registered: PropTypes.bool, // eslint-disable-line
    history: PropTypes.shape(),
  };
  static defaultProps = {
    session: {},
    error: {},
    isLoading: false,
    registered: false,
    history: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      zone: 'STUDENT',
      forgotPassword: false,
      nameErrorMessage: '',
      emailErrorMessage: '',
      passwordErrorMessage: '',
      name: '',
      firstName: '',
      lastName: '',
      password: '',
    };

    this.firstNameHandler = this.firstNameHandler.bind(this);
    this.lastNameHandler = this.lastNameHandler.bind(this);
    this.emailHandler = this.emailHandler.bind(this);
    this.passwordHandler = this.passwordHandler.bind(this);
    this.zoneHandler = this.zoneHandler.bind(this);
    this.identifyEnter = this.identifyEnter.bind(this);
    this.register = this.register.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.registered) {
      if (this.state.zone === 'COACH') {
        this.props.history.push('redirect');
      } else if (this.state.zone === 'STUDENT') {
        this.props.history.push('register/athlete');
      } else {
        this.props.history.push('register/parent');
      }
    }
  }


  firstNameHandler = (firstName) => {
    this.setState({ firstName, firstNameErrorMessage: '' });
  };

  lastNameHandler = (lastName) => {
    this.setState({ lastName, lastNameErrorMessage: '' });
  };

  emailHandler = (temp) => {
    const username = temp.toLowerCase();
    this.setState({ username, emailErrorMessage: '' });
  };
  passwordHandler = (password) => {
    this.setState({ password, passwordErrorMessage: '' });
  };

  zoneHandler = (zone) => {
    this.setState({ zone });
  };
  identifyEnter(e) {
    const code = (e.keyCode ? e.keyCode : e.which);
    if (code === 13) { // Enter keycode
      this.register();
    }
  }

  register = () => {
    const attributes = [];
    /* Name validation */
    let validFirstName = false;
    const nameError = typeof this.state.firstName === 'string';
    if (nameError && this.state.firstName !== '') {
      validFirstName = true;
    } else {
      this.setState({ firstNameErrorMessage: 'Please enter a valid first name.' });
    }
    /* Name validation */

      /* Name validation */
    let validLastName = false;
    const lastNameError = typeof this.state.lastName === 'string';
    if (lastNameError && this.state.lastName !== '') {
      validLastName = true;
    } else {
      this.setState({ lastNameErrorMessage: 'Please enter a valid last name.' });
    }
      /* Name validation */

    /* Email Validation */
    let validEmail = false;
    const emailError = regExForEmail.test(this.state.username);
    if (emailError) {
      validEmail = true;
    } else {
      this.setState({ emailErrorMessage: 'Please enter a valid email.' });
    }
    /* Email Validation */

    /* Password Validation */
    let validPassword = false;
    if (this.state.password.length > 6) {
      validPassword = true;
    } else {
      this.setState({ passwordErrorMessage: 'Password length should be greater than 7.' });
    }
    /* Password Validation */

    const combinedName = `${this.state.firstName} ${this.state.lastName}`;
    attributes.push(
      {
        Name: 'email',
        Value: this.state.username, // your email here
      },
    );
    attributes.push({
      Name: 'name',
      Value: combinedName,
    });
    attributes.push({
      Name: 'zoneinfo',
      Value: this.state.zone,
    });

    attributes.push({
      Name: 'profile',
      Value: 'PENDING',
    });

    if (validFirstName && validLastName && validEmail && validPassword) {
      this.props.registerUser(this.state.username, this.state.password, attributes);
    }
  };

  render() {
    const { error = {}, isLoading } = this.props;
        // Conditional rendering
    const renderIfLoading = renderIf(isLoading);
    const renderIfErrorIsNotEmpty = renderIf(not(isEmpty(error)));
    const renderIfNotLoading = renderIf(not(false));

    return (
      <div>
        {renderIfLoading(
          <FullScreenLoader />,
                )}

        {renderIfErrorIsNotEmpty(
          <div>
            {error.message}
          </div>,
                )}

        {renderIfNotLoading(
          <div>
            <div>
              <TextField errorMessage={this.state.firstNameErrorMessage} label="FIRST NAME" onChange={this.firstNameHandler} />
              <TextField errorMessage={this.state.lastNameErrorMessage} label="LAST NAME" onChange={this.lastNameHandler} />
              <TextField errorMessage={this.state.emailErrorMessage} usedFor="signupEmail" label="EMAIL" onChange={this.emailHandler} />
              <Password
                addForgotPassword={this.state.forgotPassword}
                onChange={this.passwordHandler}
                errorMessage={this.state.passwordErrorMessage}
                onKeyPress={this.identifyEnter}
              />
              <Category onChange={this.zoneHandler} />
              <CustomButton onClick={this.register} />
            </div>
          </div>)}
      </div>
    );
  }

}

export default Signup;



// WEBPACK FOOTER //
// ./src/components/Signup/Signup.js